/* global Stripe */
import { mapActions , mapGetters} from "vuex";

import {
  instance,
  createToken,
  setStripeAccount,
} from "vue-stripe-elements-plus-sa";

import { helpers, cartManager, enumHelper } from "@/utilities";
import { stripeOptions } from "@/stripe/config.json";

const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY, {
  apiVersion: process.env.VUE_APP_STRIPE_API_VERSION,
});
export default {
  name: "payment mixin",
  data(){
    return {
      stripeIsMounted: false,
      paymentRequestResult: null,
      canMakePayment: false,
      stripeKey: helpers.getStripeKey(),
      stripeOptions,
      availablePaymentMode: [],
    }
  },
  computed:{
    ...mapGetters([
      "getNativeApplePayStatus",
      "getNativeGooglePayStatus",
    ]),
  },
  mounted(){

    if (stripe && 
      this.selectedLocation.orderSetting.accepts_stripe && 
      !this.getNativeApplePayStatus && !this.getNativeGooglePayStatus
      ) 
      {
        this.createPaymentRequest();
      }
      this.stripeIsMounted = true;
  },
  created() {

    if (this.selectedLocation.orderSetting.accepts_stripe) {
      this.availablePaymentMode.push({
        label: this.$t("button.card_payment"),
        type: enumHelper.paymentType.Card,
        icon: "/img/card-payment-mode.svg",
      });

      if (this.getNativeApplePayStatus) {
        //-- Native Apple Pay Mode
        this.availablePaymentMode.push({
          label: "Apple Pay",
          type: enumHelper.paymentType.ApplePay,
          icon: "/img/apple-payment-mode.svg",
        });
      } 
      //-- TODO : Enable when Native Google Pay is working
      /*if (this.getNativeGooglePayStatus) {
        //-- Native Google Pay Mode
        this.availablePaymentMode.push({
          label: "Google Pay",
          type: enumHelper.paymentType.GooglePay,
          icon: "/img/google-payment-mode.svg",
        });
      }*/
      this.initCartPaymentMode()
    }

    //-- Cash Mode
    if (this.selectedLocation.orderSetting.accepts_cod &&
      this.cart.orderType != enumHelper.orderType.Table) {
      this.availablePaymentMode.push({
        label: this.$t("button.cash_payment"),
        type: enumHelper.paymentType.Cash,
        icon: "/img/cash-payment-mode.svg",
      });
    }

    this.$root.$off("PROCESS_NATIVE_PAY")
    this.$root.$on("PROCESS_NATIVE_PAY", (paymentMethodId) => {
      if(!this.processing){
        this.processNativePayment(paymentMethodId);
      }
    });

    this.$root.$off("NATIVE_PAY_FAILED");
    this.$root.$on("NATIVE_PAY_FAILED", () => {
      this.processing = false;
    });

  },
  methods: {
    ...mapActions([
      "fetchUserCardsRequest",
      "saveTrackedOrder"
    ]),
    //*********************** Start Create the PaymentRequest for The Web Apple Pay / Android Pay **************************** */
    createPaymentRequest() {
      let self = this;
      self.paymentRequestResult = stripe.paymentRequest({
        country: "GB",
        currency: "gbp",
        total: {
          label: "Order Payment from : " + self.selectedLocation.name,
          amount: parseInt((self.cart.orderTotal * 100).toFixed(0)), 
        },
      });

      // Check the availability of the Payment Request API first.
      this.paymentRequestResult.canMakePayment().then(function (result) {
        if (result) {
          self.canMakePayment = result;
          if (result.applePay) {
            self.availablePaymentMode.push({
              label: "Apple Pay",
              type: enumHelper.paymentType.ApplePay,
              icon: "/img/apple-payment-mode.svg",
            });
          } else if (result.googlePay) {
            self.availablePaymentMode.push({
              label: "Google Pay",
              type: enumHelper.paymentType.GooglePay,
              icon: "/img/google-payment-mode.svg",
            });
          }
          self.initCartPaymentMode()
        }
      });

      this.paymentRequestResult.on("token", function (token) {
        self.cart.card = token.token;
        self.cart.card.stripe_source_id = token.token.card.id;
        
        cartManager
          .generatePaymentObject(self.cart, self.selectedLocation.id)
          .then((response) => {
            if (self.isAuthenticated) self.postPayment(response, token);
            else self.PostGuestPayment(response, token);
          });
      });

      this.paymentRequestResult.on("cancel", function () {
        self.processing = false;
      });
    },
    //*********************** End Create the PaymentRequest for The Web Apple Pay / Android Pay **************************** */

    //*********************** Start Create the processPayment for Apple Pay / Android Pay (Native App )**************************** */
    startNativePay() {
      //this.processing = true;
      this.sendMessage({
        payCommand: {
          location: {
            name: this.selectedLocation.name,
            logo: this.selectedLocation.logo,
          },
          visualDetails: {
            orderId: this.cart.newOrder.id,
            orderTotal: this.cart.orderTotal, //this.options.filters.currency(this.cart.orderTotal)
          },
          details: {
            country: "GB",
            currency: "gbp",
            total: {
              label: `Pay ${this.selectedLocation.name}`, //"Order Payment From : " + this.selectedLocation.name,
              amount: this.cart.orderTotal,
            },
          },
        },
      })
    },
    processNativePayment(paymentMethodId) {
      this.cart.paymentMethodId = paymentMethodId;
      cartManager
        .generatePaymentObject(this.cart, this.selectedLocation.id, this.getNativeApplePayStatus || this.getNativeGooglePayStatus)
        .then((response) => {
          if (this.isAuthenticated) this.postPayment(response);
          else this.PostGuestPayment(response);
        });
    },
    //*********************** END Create the processPayment for Apple Pay / Android Pay (in Native App )**************************** */

    //*********************** Start API Invock to send the payment **************************** */
    postPayment(data, token=null) {
      this.makeUserPaymentRequest(data)
        .then((response) => {
          if (response && response.error) {
            this.orderFailed(
              helpers.getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          this.cart.newOrder = response.newOrder.order;
          if (this.cart.payment_type >= enumHelper.paymentType.Card) {
            if(this.cart.payment_type == enumHelper.paymentType.ApplePay && this.getNativeApplePayStatus){
              this.confirmNativeApplePayment(response.paymentIntent)
            }else{
              if(token){
                token.complete("success");
              }
              this.cart.headers = response.headers;
              this.processPaymentIntent(response);
            }
          } 
          else {
            //---- if payment is cash = display success message
            this.orderSucceed();
          }
        })
        .catch((e) => {
          //this.captureException(e);
          if (e && e.data) {
            this.orderFailed(
              helpers.getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_paying_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },

    PostGuestPayment(data, token=null) {
      this.makeGuestPaymentRequest(data)
        .then((response) => {
          if (response && response.error) {
            this.orderFailed(
              helpers.getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }

          this.cart.newOrder = response.newOrder.order;
          if (this.cart.payment_type >= enumHelper.paymentType.Card) {
            if(this.cart.payment_type == enumHelper.paymentType.ApplePay && this.getNativeApplePayStatus){
              this.confirmNativeApplePayment(response.paymentIntent)
            }else{
              if(token){
                token.complete("success");
              }
              this.cart.headers = response.headers;
              this.processPaymentIntent(response);
            }
          } 
          else {
            //---- if payment is cash = display success message
            this.orderSucceed();
          }
        })
        .catch((e) => {
          this.captureException(e);
          if (e && e.data) {
            this.orderFailed(
              helpers.getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_paying_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },
    //*********************** End API Invock to send the payment **************************** */

    //*************************** Start Stripe tokenization confirmation Methods ****************************** */
    tokenize() {
      return new Promise((resolve, reject) => {
        if (this.cart.payment_type == enumHelper.paymentType.Card) {
          if (this.cart.card_id) {
            resolve();
          } else {
            createToken()
              .then((data) => {
                if (data.error) {
                  reject(data.error);
                } else {
                  this.cart.card = data.token;
                  this.cart.card.stripe_source_id = data.token.card.id;
                  resolve();
                }
              })
              .catch((e) => {
                this.captureException(e);
                reject(e);
              });
          }
        } else if (this.cart.payment_type == enumHelper.paymentType.Cash) {
          this.cart.card_id = null;
          this.cart.card = null;
          this.clearCard();
          resolve();
        }
      });
    },
    //*************************** End Stripe tokenization confirmation Methods ****************************** */

    //*************************** Start Stripe payment confirmation Methods ****************************** */
    confirmTheCardPayement () {
      return new Promise((resolve, reject) => {
        setStripeAccount(this.cart.headers.stripe_account, this.stripeKey);
        instance
          .confirmCardPayment(this.cart.payment_intent.client_secret)
          .then(function (result) {
            resolve(result);
          })
          .catch((e) => {
            this.captureException(e);
            reject(e);
          });
      });
    },
    confirmNativeApplePayment(paymentIntent) {
      if (this.getNativeApplePayStatus &&
        this.cart.payment_type == enumHelper.paymentType.ApplePay &&
        paymentIntent &&
        paymentIntent.client_secret) {
        this.sendMessage({ confirmPayment: { status: true, client_secret: paymentIntent.client_secret || null } })
        this.orderSucceed()
      }
    },
    processPaymentIntent(result) {
      let status = result.paymentIntent ? result.paymentIntent.status : result;

      if (status === "succeeded") {
        this.orderSucceed();
      } else if (
        status === "requires_action" ||
        status === "requires_source_action"
      ) {
        this.cart.payment_intent = result.paymentIntent;
        cartManager.setCart(this.cart, false, false);
        //----- get the PayementAttend and confirm the payement
        //--- Clear the card
        let self = this;
        this.confirmTheCardPayement()
          .then((result) => {
            if (result && result.error) {
              this.paymentIntentCanceledRequest({ orderId: self.cart.id });
              this.orderFailed(
                helpers.geMessageByStripeErrorCode(result),
                this.$t("button.back_to_checkout")
              );
              return;
            }

            this.validateOrderRequest({
              orderId: self.cart.id,
              paymentIntentId: result.paymentIntent.id,
            }).then((response) => {
              if (response.success) {
                this.cart.newOrder = response.order;
                cartManager.setCart(this.cart, false, false);
              }
              this.on3DSComplete(result);
            });
          })
          .catch((e) => {
            this.captureException(e);
            this.orderFailed(
              this.$t("message.payment_failed"),
              this.$t("button.back_to_checkout")
            );
          });
      } else if (status.error) {
        this.orderFailed(
          helpers.geMessageByStripeErrorCode(status),
          this.$t("button.back_to_checkout")
        );
      } else {
        this.orderFailed(
          helpers.getMessageByStripePaymentIntent(status),
          this.$t("button.back_to_checkout")
        );
      }
    },
    on3DSComplete(result) {
      let status = result.paymentIntent ? result.paymentIntent.status : result;

      if (status === "succeeded") {
        // Show your customer that the payment has succeeded
        this.orderSucceed();
      } else if (status.error) {
        this.orderFailed(
          helpers.geMessageByStripeErrorCode(status),
          this.$t("button.back_to_checkout")
        );
      } else {
        this.orderFailed(
          helpers.getMessageByStripePaymentIntent(status),
          this.$t("button.back_to_checkout")
        );
      }
    },
    //*************************** End Stripe payment confirmation Methods ****************************** */

    //---- 
    orderSucceed() {
      this.cart.status = enumHelper.status.COMPLETED;
      this.cart.step = enumHelper.steps.STEP03;
      cartManager.setCart(this.cart, false, false);

      //-- save the order for tracking button 
      this.saveTrackedOrder({id: this.cart.newOrder.id, skip_review:false})

      localStorage.setItem("saved-order", JSON.stringify(this.cart));
      this.cart = cartManager.clearCart();
      this.processing = false;


      //-- feach the user saved cards to get the new one
      if (this.orderCompleted.save_card) {
        this.fetchUserCardsRequest();
      }
    },
    orderFailed(message, okText = this.$t("button.continue")) {
      let full_message =
        "<p><i class='k-icon-sadface' style='color:" +
        this.staticColor.red +
        "' ></i></p><p>" +
        message +
        "</p>";
      let self = this;
      let options = {
        html: true,
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm",
        okText: okText,
      };
      self.processing = false;
      this.$dialog.alert(full_message, options).then(function () {
        //self.cart.step = enumHelper.steps.STEP01;
        //cartManager.setCart(self.cart, false, false);
      });
    },
    clearCard() {
      let _cardElement = this.$refs.newCard
        ? this.$refs.newCard.$refs.element._element
        : null;
      if (_cardElement) _cardElement.clear();
    },
    initCartPaymentMode(){
      //-- TODO : Enable when Native Google Pay is working
      /*if(!this.cart.payment_type){
        this.cart.payment_type = this.getNativeApplePayStatus || (this.canMakePayment && this.canMakePayment.applePay) ? enumHelper.paymentType.ApplePay :
                              this.getNativeGooglePayStatus || (this.canMakePayment  && this.canMakePayment.googlePay) ? enumHelper.paymentType.GooglePay :
                              enumHelper.paymentType.Card             
      }*/  
      if(!this.cart.payment_type){
        this.cart.payment_type = this.getNativeApplePayStatus || (this.canMakePayment && this.canMakePayment.applePay) ? enumHelper.paymentType.ApplePay :
                              (this.canMakePayment  && this.canMakePayment.googlePay) ? enumHelper.paymentType.GooglePay :
                              enumHelper.paymentType.Card             
      }  
      
    }
  }
}